<template>
	<TeamingTypeAhead
		class="time-zone-type-ahead"
		:options="timezoneOptions"
		:placeholder="timezonePlaceholder"
	/>
</template>

<script>
import {
	default as TeamingTypeAhead,
	makeOption
} from "./TeamingTypeAhead.vue";

// eslint-disable-next-line new-cap
const { timeZone: browserTimezone, } = Intl.DateTimeFormat().resolvedOptions();
const browserTimezones = Intl.supportedValuesOf( "timeZone" );

export default {
	name: "TimeZoneTypeAhead",
	components: {
		TeamingTypeAhead,
	},
	props: {
		timezones: {
			type: Array,
			default: () => browserTimezones,
		},
	},
	computed: {
		timezoneOptions() {
			const { timezones, } = this;
			return timezones.map( timezone => makeOption( {
				text: timezone.replace( /_/g, " " ),
				value: timezone,
			} ) );
		},
		timezonePlaceholder() {
			if ( browserTimezone ) {
				return `e.g., ${ browserTimezone.replace( /_/g, " " ) }`;
			}
			return "e.g., America/New York";
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
